import { Container, Nav } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import OperationalDeploymentStats from "./OperationalDeploymentStats";
import OperationalHealth from "./OperationalHealth";

const TABS = [
  { key: "deployment-stats", title: "Deployment Stats" },
  { key: "performance", title: "Performance" },
  { key: "health", title: "Health" },
] as const;

type TabKey = (typeof TABS)[number]["key"];

const VALID_TAB_KEYS: readonly string[] = TABS.map((t) => t.key);

const TAB_TITLES: Record<TabKey, string> = {
  "deployment-stats": "Operational - Deployment Stats",
  performance: "Operational - Performance",
  health: "Operational - Health",
};

const OperationalTabs = () => {
  const { tab } = useParams<{ tab: string }>();

  const activeTab: TabKey = VALID_TAB_KEYS.includes(tab ?? "")
    ? (tab as TabKey)
    : "deployment-stats";

  document.title = TAB_TITLES[activeTab];

  return (
    <Container fluid style={{ padding: "12px 12px 0px 12px" }}>
      <Nav variant="tabs">
        {TABS.map(({ key, title }) => (
          <Nav.Item key={key}>
            <Nav.Link
              as={Link}
              to={`/operational/${key}`}
              active={activeTab === key}
              replace
            >
              {title}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      <div className="tab-content">
        <div style={{ display: activeTab === "deployment-stats" ? undefined : "none" }}>
          <OperationalDeploymentStats />
        </div>
        {activeTab === "performance" && (
          <div className="mt-3">Coming soon</div>
        )}
        <div style={{ display: activeTab === "health" ? undefined : "none" }}>
          <OperationalHealth />
        </div>
      </div>
    </Container>
  );
};

export default OperationalTabs;
